module.exports = __webpack_public_path__ + "static/img/lijunfeng.14b12b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mingpian/lijunfeng.png
// module id = sy8E
// module chunks = 0